import React from 'react';

// Bootstrap
import { Jumbotron } from 'react-bootstrap';

// Images
import Freetakistan from '../../assets/images/Freetakistan.png';
import modoAdm from '../../assets/images/tutoriais/modoAdm.png';
import aceclippi from '../../assets/images/tutoriais/aceclippi.png';
import instaladorAcre from '../../assets/images/tutoriais/instaladorAcre.png';

// Components
import Header from '../../components/Header/index';

// Material-ui
import { Typography, Link } from '@material-ui/core';

// Style
import './tutoriais.css';

const Tutoriais = () => {

    return (
        <div>
            <Header />
            <Jumbotron className="text-center">
                <img src={Freetakistan} alt='Freetakistan Logo' style={{ width: '150px', marginBottom: '1em' }} />

                <h1>Free Takistan</h1>
                <p>
                    Uma comunidade focada em jogos de simulação militar e automobilística, com o objetivo de divulgar informação e crescimento mútuo!
                </p>
            </Jumbotron>

            <div className="text-container">
                <Typography component="h4" variant="h4" style={{ textAlign: 'center', marginBottom: '1em', fontWeight: 'bold' }}>
                    Como instalar os Mods do Arma 2
                </Typography>
                <Typography component="h5" variant="h5" style={{ textAlign: 'center', marginBottom: '2em' }}>
                    Primeiramente, entre nos links abaixo para baixar nossos 2 pacotes de Mods que utilizamos no FreeTakistan.
                </Typography>

                <hr />
                <Typography component="article" variant="subtitle2" style={{ fontSize: '1.5em' }}>
                    Pacotão de Mods Essenciais (ACE - ACRE)
                </Typography>

                <Link rel="noopener" target="_blank" href="https://drive.google.com/drive/folders/1fOg_pvi5X_vh42TTLws4mbJQNBKUkOav">Download Pacotão de Mods Essenciais</Link>
                <hr />
                <Typography component="article" variant="subtitle2" style={{ fontSize: '1.5em' }}>
                    Pacotão de Mapas
                </Typography>

                <Link rel="noopener" target="_blank" href="https://drive.google.com/drive/folders/1vYQc4Ulhn7_9XwyVE3P9jaododV5Wjmn">Download Pacotão de Mapas</Link>
                <hr />

                <Typography component="h5" variant="h5" style={{ marginTop: '2em', marginBottom: '1em' }}>
                    Após baixar os dois pacotes, descompacte os arquivos. Inicialmente começaremos a instalar os <strong style={{ color: 'red' }}>Mods Essenciais</strong>.
                </Typography>

                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em' }}>
                    <strong style={{ color: 'blue' }}>Passo 1:</strong> Na pasta "pacotão de mods essenciais", copiar todos as pastas que existem dentro
                    da mesma e colar na pasta Arma 2, em meus documentos:
                </Typography>

                <Typography component="article" variant="caption" style={{ fontSize: '1em', margin: '1em' }}>
                    (Disco Local:\Users\nome\Documents\ArmA 2)
                </Typography>
                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em', margin: '1em' }}>
                    Ou você pode colar no diretório do jogo, fica à sua escolha:
                </Typography>
                <Typography component="article" variant="caption" style={{ fontSize: '1em', margin: '1em' }}>
                    (Disco Local:\Steam\steamapps\common\Arma 2 Operation Arrowhead)
                </Typography>

                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em', marginBottom: '1em' }}>
                    Você pode fazer o mesmo processo de copiar e colar todos os mods do <strong style={{ color: 'blue' }} >Pacotão de Mapas</strong> também, pois o processo é idêntico.
                </Typography>

                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em' }}>
                    <strong style={{ color: 'blue' }}>Passo 2:</strong> Copiar a pasta "userconfig" e colar no diretório do jogo.
                    Caso seja a primeira vez que você esteja instalando os mods, não irá existir esta pasta no seu diretório,
                    caso exista recomendo excluir e colar o userconfig do pacote.
                    (Isto serve para configurar o seu jogo para com os mods).
                </Typography>
                <Typography component="article" variant="caption" style={{ fontSize: '1em', margin: '1em' }}>
                    (Disco Local:\Steam\steamapps\common\Arma 2 Operation Arrowhead)
                </Typography>

                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em', marginBottom: '1em' }}>
                    <strong style={{ color: 'blue' }}>Passo 3 (programas de comunicação):</strong> Na pasta "Instalador de mods de comunicação" existe
                    uma pasta "Instalador ACRE". Dentro dela, haverá um instalador para o mod de comunicação que usamos no FreeTakistan chamado ACRE (Advanced Combat Radio Environment),
                    abra o executável e instale o programa onde desejar. O instalador
                    irá adicionar o TS3 com a versão antiga (3.0.13) e os mods @Acre e @Jayarma2lib
                    (dependência do ACRE), estes dois mods já se encontram na pasta "pacotão de mods essenciais".
                </Typography>

                <div className='text-center'>
                    <img src={instaladorAcre} alt='Instalando TS3 + ACRE' style={{ width: '500px', margin: '1em' }} />
                </div>

                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em', marginBottom: '1em' }}>
                    <strong style={{ color: 'red' }}>Aviso:</strong> O ACRE necessita de uma versão específica do TS3 antiga (3.0.13) para que funcione corretamente.
                    Somente esta versão é compatível com o ACRE, as mais atualizadas não funcionam. Por isso, quando abrir o TS3 e vir um aviso de atualização,
                    <strong style={{ color: 'red' }}> nunca atualize-o</strong>.
                </Typography>
                <br />
                <hr />
                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em', marginBottom: '1em' }}>
                    Materiais de apoio adicionais para a instalação do TS3 + ACRE caso haja necessidade, o vídeo a seguir foi realizado por membro do FreeTakistan:
                </Typography>

                <Link rel="noopener" target="_blank" href="https://www.youtube.com/watch?v=t93v1bjI4oA">Tutorial como instalar o TS3 + ACRE</Link>

                <Typography component="h5" variant="h5" style={{ marginTop: '1', marginBottom: '1em', textAlign: 'center' }}>
                    <strong style={{ color: 'blue' }}>IP TS3 do FreeTakistan:</strong> free-takistan.ddns.net
                </Typography>
                <hr />
                <br />

                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em', marginBottom: '1em' }}>
                    <strong style={{ color: 'blue' }}>Passo 4 (modo de administrador):</strong> Este passo é muito importante para o correto funcionamento do ACRE. Você deverá
                    ir no diretório do seu jogo e do seu TS3 e definir seus executáveis para sempre abrir em "modo administrador". O nome do executável do arma 2 é <strong style={{ color: 'red' }}>ArmA2OA.exe </strong>
                    e o do TS3 você poderá acessar pelo próprio atalho em sua área de trabalho, ou se preferir, abra o diretório onde instalou o seu TS3 e procure o arquivo <strong style={{ color: 'red' }}>ts3client_win32.exe</strong>.
                    <br /><br />
                    Em seguida, você clicará com o botão direito do mouse no executável, clicará em Propriedades, depois em Compatibilidade, procure a caixa de opção com o nome
                    "Executar este programa como administador", marque-a e aplique a mudança. Este processo deverá ser feito nos dois executáveis (ArmA2OA.exe e ts3client_win32.exe, ou o atalho do mesmo).
                </Typography>

                <div className='text-center'>
                    <img src={modoAdm} alt='Configurando para o modo administrador' style={{ width: '400px', margin: '1em' }} />
                </div>

                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em', marginBottom: '1em' }}>
                    <strong style={{ color: 'blue' }}>Passo 5 (configurando o ace clip):</strong> Antes de iniciar este último passo, você deverá abrir os dois Arma's (Arma 2 e Arma 2 Operation Arrowhead) pela primeira vez (caso ainda não tenha feito).
                    <br /><br />
                    Abra primeiro o <strong style={{ color: 'red' }}>Arma 2</strong> e depois o <strong style={{ color: 'red' }}>Arma 2 Operation Arrowhead</strong>.
                    <br /><br />
                    Após abrir o Arma 2 Operation Arrowhead, crie um perfil na aba "Profiles" ou mantenha o padrão que irá ser criado automaticamente.
                    <br /><br />
                    Logo em seguida, feche o jogo e vá na pasta onde você colocou todos os mods dos pacotes no <strong style={{ color: 'red' }}>Passo 1</strong>:
                </Typography>

                <Typography component="article" variant="subtitle2" style={{ fontSize: '1em', marginBottom: '1em' }}>
                    Procure a pasta do mod chamado @ace, abra e clique na pasta "clippi". Nesta pasta haverá um executável de nome <strong style={{ color: 'red' }}>aceclippi.exe</strong>, abra-o.
                    <br /><br />
                    Quando aparecer uma janela, clique no botão "Alterar opções manuais". Aparecerá outra janela, onde nela você deverá selecionar a sua identidade (o seu perfil que foi criado no Arma 2).
                    No campo "Selecione sua identidade", clique no nome do perfil que você acabou de criar sem os caracteres ".vars".
                    <br /><br />
                    Após selecionar, clique em Guardar e poderá fechar todas as janelas.
                </Typography>

                <div className='text-center'>
                    <img src={aceclippi} alt='Configurando o aceclippi' style={{ width: '1000px', margin: '1em' }} />
                </div>

                <Typography component="h5" variant="h5" color="primary" style={{ textAlign: 'center', margin: '2em' }}>
                    Após todo o procedimento, se você fez tudo conforme está neste passo a passo, seu Arma 2 já esta configurado com todos os mods
                    que usamos e você conseguirá entrar em qualquer um de nossos servidores! Bom jogo =)
                </Typography>
            </div>

        </div>
    );
}

export default Tutoriais;